import { useState } from "react";
import Tabs, { TabOption } from "../Tabs";
import ManulPanel from "./ManulPanel";
import AutoPanel from "./AutoPanel";

const TradePanels = ({
    refreshFunc,
    subnetInfo,
    traderData
}: {
    refreshFunc: () => void;
    subnetInfo: any;
    traderData: any;
}) => {
    const [activeTab, setActiveTab] = useState<'manual' | 'auto'>('manual');
    const tabs: TabOption[] = [
        { key: 'manual', label: 'Manual' },
        { key: 'auto', label: 'Auto' },
    ];

    return <div>
        <Tabs
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={(tabKey) => setActiveTab(tabKey as 'manual' | 'auto')}
        />
        {activeTab === 'manual' && <ManulPanel refreshFunc={refreshFunc} subnetInfo={subnetInfo} traderData={traderData} />}
        {activeTab === 'auto' && <AutoPanel subnetInfo={subnetInfo} refreshFunc={refreshFunc}/>}

    </div>;
};

export default TradePanels;
